import { Helmet, HelmetProvider } from "react-helmet-async";

import hero_image_png from "../assets/Hero.png";
import hero_image_webp from "../assets/Hero.webp";
import hero_image_avif from "../assets/Hero.avif";
import shine_image_png from "../assets/Shine.png";
import shine_image_webp from "../assets/Shine.webp";
import shine_image_avif from "../assets/Shine.avif";

import stars_image from "../assets/Stars.svg";

import { useSolanaWalletModal } from "../Contexts/useSolanaWalletModal";

const HOW_TO_SWAP_URL = process.env.REACT_APP_HOW_TO_SWAP_URL;

export function LandingPage() {
    const { setVisible } = useSolanaWalletModal();
    return (
        <HelmetProvider>
            <Helmet>
                <link
                    rel="preload"
                    fetchpriority="high"
                    href={hero_image_avif}
                    as="image"
                    type="image/avif"
                />
                <link
                    rel="preload"
                    fetchpriority="high"
                    href={shine_image_avif}
                    as="image"
                    type="image/avif"
                />
            </Helmet>
            <main className="flex justify-center">
                <div className="grid-row-2 grid lg:grid-cols-2 lg:grid-rows-none lg:items-center">
                    <div className="relative z-20 px-6 pt-12 pb-6">
                        <div className="flex flex-col items-center lg:items-start">
                            <div className="inline-flex items-center rounded-full border border-gray-100 bg-white px-4 py-2 text-sm font-bold uppercase text-purple-900">
                                Neocollectible Holders Only
                            </div>
                            <h1 className="relative mt-5 overflow-visible font-burbank text-4xl font-medium text-gray-800 lg:mt-10 lg:text-5xl xl:text-6xl">
                                Swap to{" "}
                                <span className="text-purple-900">Polygon</span>
                                <div className="absolute -right-12 -top-7 z-10 hidden w-max lg:block">
                                    <img src={stars_image} alt="Stars" />
                                </div>
                            </h1>
                            <p className="mt-4 text-center text-base text-gray-800 lg:mt-6 lg:text-lg lg:text-gray-500 xl:text-xl">
                                Swap your Neocollectible on Solana to Polygon
                                today!
                            </p>
                            <div className="mt-8 flex flex-col items-center justify-center gap-4 lg:mt-16 lg:flex-row lg:gap-6">
                                <button
                                    onClick={(event) => {
                                        event.preventDefault();
                                        setVisible(true);
                                    }}
                                    type="button"
                                    className="w-full rounded-full border border-transparent bg-orange-600 px-6 py-2.5 font-burbank text-xl font-semibold text-white shadow-inner hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 lg:w-fit"
                                >
                                    Connect Solana Wallet
                                </button>
                                <a
                                    className="grow py-1 text-base font-bold text-gray-800"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={HOW_TO_SWAP_URL}
                                >
                                    How to swap?
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="relative z-0 flex justify-center overflow-visible">
                        <div className="relative z-10 max-w-max lg:max-w-lg xl:max-w-none">
                            <picture className="w-full">
                                <source
                                    type="image/avif"
                                    srcSet={hero_image_avif}
                                />
                                <source
                                    type="image/webp"
                                    srcSet={hero_image_webp}
                                />
                                <img
                                    src={hero_image_png}
                                    alt="Swap NFT from Solana to Polygon"
                                    width="640"
                                    height="640"
                                    loading="eager"
                                />
                            </picture>
                        </div>
                        <div
                            className="absolute z-0 box-border rounded-full"
                            style={{
                                top: "-25%",
                                width: "140%",
                            }}
                        >
                            <picture className="w-full">
                                <source
                                    type="image/avif"
                                    srcSet={shine_image_avif}
                                />
                                <source
                                    type="image/webp"
                                    srcSet={shine_image_webp}
                                />
                                <img
                                    src={shine_image_png}
                                    alt="Shine"
                                    width="800"
                                    height="800"
                                    loading="eager"
                                />
                            </picture>
                        </div>
                    </div>
                </div>
            </main>
        </HelmetProvider>
    );
}
